import { render, staticRenderFns } from "./single-file-upload.vue?vue&type=template&id=cd85c30a&"
import script from "./single-file-upload.vue?vue&type=script&lang=js&"
export * from "./single-file-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports